import React, { useState } from 'react';
import Navbar from '@/components/Navbar';
import Footer from '@/components/Footer';
import { Button } from '@/components/ui/button';
import { CheckCircle } from 'lucide-react';
import PageMeta from '@/components/SEO/PageMeta';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from '@/components/ui/dialog';
import AppointmentCalendar from '@/components/appointment/AppointmentCalendar';

const Approche = () => {
  const [isCalendarOpen, setIsCalendarOpen] = useState(false);
  
  const steps = [
    {
      title: "Analyse complète de votre situation",
      description: "Nous commençons par une analyse approfondie de votre situation financière, familiale et professionnelle pour comprendre vos objectifs et contraintes."
    },
    {
      title: "Élaboration d'une stratégie sur mesure",
      description: "Nous définissons une stratégie patrimoniale personnalisée qui répond à vos objectifs à court, moyen et long terme."
    },
    {
      title: "Mise en œuvre des solutions",
      description: "Nous vous accompagnons dans la mise en œuvre de votre stratégie patrimoniale avec des solutions concrètes et adaptées."
    },
    {
      title: "Suivi et ajustement",
      description: "Nous assurons un suivi régulier de votre patrimoine et ajustons la stratégie en fonction de l'évolution de votre situation et des marchés."
    }
  ];

  const advantages = [
    "Une expertise reconnue dans le domaine de la gestion de patrimoine",
    "Une approche personnalisée et sur mesure pour chaque client",
    "Une indépendance totale dans nos recommandations",
    "Une transparence absolue sur nos honoraires",
    "Un accompagnement continu et un suivi régulier",
    "Des solutions innovantes et adaptées à vos besoins"
  ];

  return (
    <div className="min-h-screen flex flex-col">
      <PageMeta 
        title="Approche de La Patrimoniale - Méthodologie Gestion de Patrimoine sur Mesure"
        description="Découvrez l'approche méthodologique unique de La Patrimoniale à Paris : une analyse patrimoniale approfondie, une stratégie personnalisée, une mise en œuvre transparente et un suivi rigoureux. La Patrimoniale place votre projet au cœur de ses priorités avec indépendance, expertise reconnue, transparence et accompagnement sur-mesure, pour optimiser, protéger et faire fructifier votre patrimoine à chaque étape de votre vie."
        keywords="La Patrimoniale, approche gestion patrimoine, méthode optimisation fiscale, gestion patrimoniale personnalisée, stratégie patrimoniale La Patrimoniale, accompagnement patrimonial Paris, expertise gestion patrimoine, suivi patrimoine"
        canonical="https://www.la-patrimoniale-gestion.com/approche"
      />
      <Navbar />
      
      <main className="flex-grow pt-20">
        <section className="py-12 bg-gray-50">
          <div className="container mx-auto px-6">
            <h1 className="section-title text-center mb-4">Notre Approche</h1>
            <p className="text-center text-patrimoine-muted max-w-2xl mx-auto mb-12">
              Découvrez notre méthodologie pour vous accompagner vers la réussite financière et patrimoniale.
            </p>
            
            <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-16">
              <div>
                <h2 className="text-2xl font-serif font-semibold mb-6 text-patrimoine-DEFAULT">Notre Méthode</h2>
                <div className="space-y-8">
                  {steps.map((step, index) => (
                    <div key={index} className="flex">
                      <div className="mr-4 bg-patrimoine-gold rounded-full h-8 w-8 flex items-center justify-center text-white font-bold flex-shrink-0">
                        {index + 1}
                      </div>
                      <div>
                        <h3 className="font-serif font-medium text-lg mb-2">{step.title}</h3>
                        <p className="text-patrimoine-muted">{step.description}</p>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
              
              <div>
                <h2 className="text-2xl font-serif font-semibold mb-6 text-patrimoine-DEFAULT">Nos Avantages</h2>
                <div className="bg-white p-6 rounded-lg shadow-sm">
                  <ul className="space-y-4">
                    {advantages.map((advantage, index) => (
                      <li key={index} className="flex items-start">
                        <CheckCircle className="h-5 w-5 mr-2 mt-0.5 text-patrimoine-gold flex-shrink-0" />
                        <span>{advantage}</span>
                      </li>
                    ))}
                  </ul>
                  
                  <div className="mt-8">
                    <Button 
                      className="cta-button w-full"
                      onClick={() => setIsCalendarOpen(true)}
                    >
                      Prendre rendez-vous
                    </Button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>
      
      <Dialog open={isCalendarOpen} onOpenChange={setIsCalendarOpen}>
        <DialogContent className="sm:max-w-[400px] p-4">
          <DialogHeader className="pb-2">
            <DialogTitle className="text-center font-serif text-base">Prendre Rendez-vous</DialogTitle>
            <DialogDescription className="text-center text-xs">
              Sélectionnez une date et un horaire
            </DialogDescription>
          </DialogHeader>
          <AppointmentCalendar onClose={() => setIsCalendarOpen(false)} />
        </DialogContent>
      </Dialog>
      
      <Footer />
    </div>
  );
};

export default Approche;
